export default class Parameters {

	constructor (data) {
		if (data) {
			this.id = parseInt(data.id)
			this.name = data.name
			this.min = data.min
			this.max = data.max
			this.interval_min_start = data.interval_min_start
			this.interval_min_end = data.interval_min_end
			this.interval_max_start = data.interval_max_start
			this.interval_max_end = data.interval_max_end
			this.urgency_type = data.urgency_type
		} else {
			this.name = ''
			this.min = ''
			this.max = ''
			this.interval_min_start = ''
			this.interval_min_end = ''
			this.interval_max_start = ''
			this.interval_max_end = ''
			this.urgency_type = ''
		}
	}
}



// WEBPACK FOOTER //
// ./src/classes/Parameters.js